import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function Login() {
  const { login, startDemo } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [demoBusy, setDemoBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) nav("/");
    else setErr(r.error);
  };

  const tryDemo = async () => {
    setErr("");
    setDemoBusy(true);
    const r = await startDemo();
    setDemoBusy(false);
    if (r.ok) nav("/");
    else setErr(r.error);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-[var(--rw-bg)]">
      <div className="hidden md:block relative bg-black">
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 p-12 text-white">
          <img
            src="https://customer-assets.emergentagent.com/job_ristwatch-crm/artifacts/304sorwq_logosd.png"
            alt="RistWatch"
            className="h-24 w-auto"
            data-testid="login-brand"
          />
          <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">
            Welcome back, <span className="rgb-glow">Mike</span>
          </h1>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-10 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="md:hidden flex items-center justify-center mb-8">
            <img src="https://customer-assets.emergentagent.com/job_ristwatch-crm/artifacts/304sorwq_logosd.png" className="h-14 w-auto" alt="RistWatch" />
          </div>
          <div className="label-eyebrow mb-2">Sign In</div>
          <h2 className="font-display text-3xl font-bold mb-2">Welcome back.</h2>
          <p className="text-sm text-neutral-500 mb-8">
            Enter your credentials to access your CRM.
          </p>
          <div className="space-y-4">
            <div>
              <label className="label-eyebrow block mb-1.5">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="label-eyebrow block mb-1.5">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
            {err && (
              <div className="text-xs text-red-600 bg-red-50 border border-red-100 px-3 py-2 rounded" data-testid="login-error">
                {err}
              </div>
            )}
            <Button type="submit" className="w-full bg-[var(--rw-sidebar)] hover:bg-[var(--rw-sidebar-hover)]" disabled={busy} data-testid="login-submit">
              {busy ? "Signing in…" : "Sign In"}
            </Button>
          </div>

          <div className="flex items-center my-6 gap-3">
            <div className="flex-1 h-px bg-[var(--rw-border)]" />
            <span className="label-eyebrow">or</span>
            <div className="flex-1 h-px bg-[var(--rw-border)]" />
          </div>

          <button
            type="button"
            onClick={tryDemo}
            disabled={demoBusy}
            className="w-full border border-[var(--rw-border)] rounded-[4px] px-4 py-3 text-sm hover:bg-[var(--rw-surface-2)] transition-colors text-left flex items-center gap-3"
            data-testid="try-demo-btn"
          >
            <span className="nav-dot" style={{ background: "var(--rw-dot-intros)" }} />
            <div className="flex-1">
              <div className="font-semibold">{demoBusy ? "Spinning up your demo…" : "Try the live demo"}</div>
              <div className="text-xs text-neutral-500">No sign-up. Pre-loaded sample data. Wiped after 24h.</div>
            </div>
          </button>
        </form>
      </div>
    </div>
  );
}
